import { ref, watch, computed, reactive } from "vue";
import auth from "./firebaseAuth";
import api from "@/composables/api";
import { useQb } from "@/stores";
import { useReCaptcha } from "vue-recaptcha-v3";

export default () => {
  const qbStore = useQb();

  const hashId = ref("");
  const currentComponent = ref("");
  const invoiceStatus = ref("");
  const invoiceAmount = ref("");
  const invoiceCardAmount = ref("");
  const reviewStatus = ref("");
  const stripeLink = ref("");
  const settings = reactive({ value: {} });
  const isReviewFirst = ref(false);
  const feedbackSubmitted = ref(true);
  const clickEvents = [];

  if (window.location.href.includes("reviewId")) {
    hashId.value = window.location.href.split("reviewId=")[1];
  } else {
    hashId.value = window.location.href.split("/").pop();
  }

  const sendClickEvents = () => {
    // console.log("sending click events");
    // console.log(clickEvents);
    if (clickEvents.length > 0) {
      // console.log("sending click events in if");
      const blob = new Blob([JSON.stringify({ clickEvents })], {
        type: "application/json",
      });
      navigator.sendBeacon(
        `${import.meta.env.VITE_APP_API_BASE_URL}v1/reviewer/click/${
          hashId.value
        }/`,
        blob
      );

      clickEvents.length = 0;
    }
  };

  const recordClick = (eventType, value = "") => {
    if (value !== "") {
      clickEvents.push({
        eventType,
        timestamp: new Date().toISOString(),
        value,
      });
      return;
    }

    clickEvents.push({
      eventType,
      timestamp: new Date().toISOString(),
    });
  };

  const lastNode = window.location.href.split("/").pop();
  let setupRecaptcha = () => {};
  if (import.meta.env.VITE_APP === "production") {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();
    setupRecaptcha = async (action) => {
      await recaptchaLoaded();
      const token = await executeRecaptcha(action);
      return token;
    };
  }

  const updateFeedback = (finalFeedback) => {
    api(`v1/review/update/${lastNode}/`, {
      method: "PUT",
      body: {
        feedback: finalFeedback,
      },
    })
      .then((res) => {
        // console.log(res);
        setTimeout(() => {
          feedbackSubmitted.value = true;
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cardCharge = async (data) => {
    let captcha = "";
    if (import.meta.env.VITE_APP === "production") {
      captcha = await setupRecaptcha("cardCharge");
    }
    data.hashId = hashId.value;
    data.recaptchaToken = captcha;
    const chargeResult = await qbStore.chargeQb(data);
    return chargeResult;
  };

  return {
    currentComponent,
    hashId,
    invoiceStatus,
    invoiceAmount,
    invoiceCardAmount,
    reviewStatus,
    stripeLink,
    updateFeedback,
    settings,
    feedbackSubmitted,
    cardCharge,
    recordClick,
    sendClickEvents,
    isReviewFirst,
  };
};
